// api
import axios from 'axios';
import { url } from 'utils/urls';
// POST        /v1/accounts/images
export const uploadImage = (accountUUID, imageFile, isLogo) => {
    const data = new FormData();
    data.append('accountUUID', accountUUID);
    data.append('logo', `${isLogo}`);
    data.append('imagesCount', '1');
    data.append('images[0]', imageFile);
    const headers = { 'Content-Type': 'multipart/form-data' };
    return axios.post(url.accounts.images, data, { headers, withCredentials: true })
};